import { Button, CheckBox } from "devextreme-react";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import notify from "../../lib/notify";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { acceptRegulation } from "../../api/auth";
import { useAuth } from "../../contexts/auth";
import GeneralDataProtectionRegulationContent from "./GeneralDataProtectionRegulationContent";

export default function GeneralDataProtectionRegulationAcceptancePopup() {
  const { t } = useTranslation();
  const { setRegulationAccepted } = useAuth();

  const [accepted, setAccepted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSaveButtonClick = useCallback(async () => {
    setIsLoading(true);

    try {
      await acceptRegulation("GeneralDataProtectionRegulation");
      setRegulationAccepted("GeneralDataProtectionRegulation");
    } catch (error) {
      notify(
        error instanceof Error
          ? error.message
          : t("common.unknownErrorOccurred"),
        "error",
        5000,
      );
    } finally {
      setIsLoading(false);
    }
  }, [setRegulationAccepted, t]);

  return (
    <Popup visible fullScreen showTitle={false} showCloseButton={false}>
      <GeneralDataProtectionRegulationContent />
      <ToolbarItem toolbar="bottom" location="before">
        <div className="flex items-center gap-2">
          <CheckBox
            defaultValue={false}
            text={t("iHaveReadAndAccept")}
            onValueChanged={(event) => setAccepted(event.value)}
            disabled={isLoading}
          />
          <Button
            stylingMode="contained"
            type="default"
            text={t("save")}
            onClick={handleSaveButtonClick}
            disabled={isLoading || !accepted}
          />
        </div>
      </ToolbarItem>
    </Popup>
  );
}
